import type { ReceiptTemplate } from '../schema';

export const adidasTemplate: ReceiptTemplate = {
  id: 'adidas',
  name: 'Adidas Receipt',
  brand: 'ADIDAS',
  description: 'Adidas sportswear and footwear receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'adidas-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/adidas.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'adidas-store-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'store', label: 'Store #:', value: '4892' },
          { id: 'trans', label: 'Trans #:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'adidas-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'ULTRABOOST 22 SHOES', quantity: '1', price: '190.00', sku: '847291034' },
          { id: '2', name: 'TREFOIL TEE', quantity: '2', price: '35.00', sku: '847291035' },
          { id: '3', name: 'ADILETTE SLIDES', quantity: '1', price: '45.00', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'adidas-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '305.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX (8.25%)', value: '25.16', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '330.16', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'adidas-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [
          { id: 'auth', label: 'Auth Code:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'adidas-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'IMPOSSIBLE IS NOTHING\n\nReturn within 30 days with receipt\nwww.adidas.com',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

